import { FormEvent, useEffect, useState } from "react";
import { api, payload } from "./lib/api";

interface Redirect {
  id: string;
  oldPath: string;
  newPath: string;
  statusCode: 301 | 302;
  createdAt: string;
}
export default function RedirectManager({ siteId }: { siteId: string }) {
  const [items, setItems] = useState<Redirect[]>([]);
  const [open, setOpen] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api<{ redirects: Redirect[] }>(`/api/sites/${siteId}/redirects`)
      .then((result) => setItems(result.redirects))
      .catch((cause) => setError(cause.message));
  }, [siteId]);
  async function create(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const form = event.currentTarget;
    try {
      const result = await api<{ redirect: Redirect }>(
        `/api/sites/${siteId}/redirects`,
        payload("POST", Object.fromEntries(new FormData(form))),
      );
      setItems((current) => [result.redirect, ...current]);
      form.reset();
      setOpen(false);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Redirect non salvato");
    } finally {
      setBusy(false);
    }
  }
  async function remove(item: Redirect) {
    if (!window.confirm(`Eliminare il redirect da ${item.oldPath}?`)) return;
    try {
      await api(`/api/sites/${siteId}/redirects/${item.id}`, payload("DELETE"));
      setItems((current) =>
        current.filter((redirect) => redirect.id !== item.id),
      );
    } catch (cause) {
      setError(
        cause instanceof Error ? cause.message : "Eliminazione non riuscita",
      );
    }
  }
  return (
    <section className="redirect-panel">
      <div className="redirect-head">
        <div>
          <p className="eyebrow indigo">Gestione URL</p>
          <h3>Redirect 301 e 302</h3>
          <p>
            Conserva traffico e collegamenti quando una pagina cambia indirizzo.
          </p>
        </div>
        <button className="primary" onClick={() => setOpen((value) => !value)}>
          {open ? "Chiudi" : "Nuovo redirect"}
        </button>
      </div>
      {error && <div className="notice">{error}</div>}
      {open && (
        <form onSubmit={create} className="redirect-form">
          <label>
            Vecchio percorso
            <input name="oldPath" placeholder="/vecchia-pagina" required />
          </label>
          <label>
            Nuova destinazione
            <input name="newPath" placeholder="/nuova-pagina" required />
          </label>
          <label>
            Tipo
            <select name="statusCode" defaultValue="301">
              <option value="301">301 permanente</option>
              <option value="302">302 temporaneo</option>
            </select>
          </label>
          <button className="primary" disabled={busy}>
            {busy ? "Salvataggio…" : "Salva redirect"}
          </button>
        </form>
      )}
      <div className="redirect-list">
        {items.map((item) => (
          <article key={item.id}>
            <code>{item.oldPath}</code>
            <span>→</span>
            <code>{item.newPath}</code>
            <strong>{item.statusCode}</strong>
            <button
              onClick={() => remove(item)}
              aria-label={`Elimina redirect ${item.oldPath}`}
            >
              ×
            </button>
          </article>
        ))}
        {!items.length && <p>Nessun redirect configurato.</p>}
      </div>
    </section>
  );
}
